import { createContext } from 'react';
import type { User } from '@supabase/supabase-js';

export interface AuthContextValue {
  user: User | null;
  isAdmin: boolean;
  isRecovery: boolean;
  loading: boolean;
  signOut: () => Promise<void>;
  clearRecovery: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
